import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { EToastvariant } from "../../config/interfaces";
import { RootState } from "../Store";

interface ToastState {
	message: string;
	isVisible?: boolean;
	title?: string;
	variant?: EToastvariant;
}

const initialState: ToastState = {
	message: "",
	isVisible: false,
	title: "",
	variant: EToastvariant.Success
};

const ToastMsgSlice = createSlice({
	name: "toastMsgSlice",
	initialState,
	reducers: {
		showToastMsg: (state, action: PayloadAction<ToastState>) => {
			state.isVisible = true;
			state.message = action.payload.message;
			state.title = action.payload?.title || "";
			state.variant = action.payload?.variant || EToastvariant.Danger;
		},
		hideToastMsg: (state) => {
			state.isVisible = false;
		}
	}
});

export const { showToastMsg, hideToastMsg } = ToastMsgSlice.actions;

export const selectorToast = (rootState: RootState) => rootState.toastReducer;

export default ToastMsgSlice.reducer;
